import { Link, useLocation, Navigate } from "react-router-dom";

import type { ReplayUploadOut } from "@/api/upload";
import { PageHeader } from "@/components/PageHeader";

export function UploadResultPage() {
  const location = useLocation();
  const result = (location.state as { result?: ReplayUploadOut } | null)?.result;

  if (!result) return <Navigate to="/flights/upload" replace />;

  return (
    <>
      <PageHeader
        title={result.message}
        lede={
          <>
            Operation status:{" "}
            <span className={`status-pill ${result.status}`}>
              {result.status}
            </span>
          </>
        }
        actions={
          <>
            <Link className="button primary" to="/flights/upload">
              Another import
            </Link>
            <Link className="button ghost" to="/flights">
              Flight list
            </Link>
          </>
        }
      />

      <div className="grid two-up">
        <article className="panel">
          <div className="panel-head">
            <h2>Import audit</h2>
          </div>
          {result.upload_id !== null ? (
            <dl className="detail-grid">
              <div>
                <dt>File</dt>
                <dd>{result.title ?? "-"}</dd>
              </div>
              <div>
                <dt>Owner</dt>
                <dd>{result.username}</dd>
              </div>
              <div>
                <dt>Upload ID</dt>
                <dd className="mono">#{result.upload_id}</dd>
              </div>
              <div>
                <dt>Status</dt>
                <dd>{result.status}</dd>
              </div>
            </dl>
          ) : (
            <p className="empty-state">No import audit record was created.</p>
          )}
        </article>

        <article className="panel">
          <div className="panel-head">
            <h2>Parsing result</h2>
          </div>
          {result.flight_id !== null ? (
            <>
              <dl className="detail-grid">
                <div>
                  <dt>Flight title</dt>
                  <dd>{result.title ?? "-"}</dd>
                </div>
                <div>
                  <dt>Session</dt>
                  <dd>{result.session_name ?? "-"}</dd>
                </div>
                <div>
                  <dt>Replay ID</dt>
                  <dd>{result.replay_id ?? "-"}</dd>
                </div>
              </dl>
              <div className="panel-actions">
                <Link className="button primary" to={`/flights/${result.flight_id}`}>
                  Open analytics detail
                </Link>
              </div>
            </>
          ) : (
            <p className="empty-state">The flight was not saved to the application database.</p>
          )}
        </article>
      </div>
    </>
  );
}
